import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpService } from './service/http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  user: any;
  constructor (private router: Router, private http: HttpService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.http.localStorageGetItem('admin_token')) {
      return true;
    } else {
      this.router.navigate(['/oAuth/login']);
      return false;
    }
  }
}
